import React from 'react';

const TermsAndPolicy = () => {
    return (
        <div className="bg-white rounded-lg shadow p-6">
            <h1 className="text-3xl font-semibold mb-4">Terms and Privacy Policy</h1>
            <p className="text-gray-700 mb-4">
                Welcome to <a href="https://academy-nest.com" className="font-semibold text-blue-600 hover:underline">academy-nest.com</a>. By accessing and using our platform, you agree to abide by these Terms and Privacy Policy. Please read them carefully.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2">1. User Accounts</h2>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
                <li>
                    <span className="font-semibold">Account Registration:</span> Provide accurate information during registration. Each account is personal and must not be shared.
                </li>
                <li>
                    <span className="font-semibold">Account Security:</span> You are responsible for maintaining the confidentiality of your login credentials and all activities under your account.
                </li>
                <li>
                    <span className="font-semibold">Eligibility:</span> Users must be at least 13 years old or meet the minimum age requirement in their country to use the platform.
                </li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6 mb-2">2. Privacy Policy</h2>
            <p className="text-gray-700 mb-4">
                Your privacy is important to us. We collect and securely store only the necessary information required for providing a seamless learning experience. We do not share your personal information with third parties without your consent.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2">3. Data Security</h2>
            <p className="text-gray-700">
                We use advanced encryption and security measures to protect your data. All session and personal information is handled securely, and you can manage your privacy preferences through your account settings.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2">4. Changes to Terms and Privacy Policy</h2>
            <p className="text-gray-700">
                We may update these policies periodically. Continued use of the platform after any updates indicates your acceptance of the revised terms.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2">5. Contact Us</h2>
            <p className="text-gray-700">
                If you have any questions or concerns about these Terms and Privacy Policy, please reach out to us at{" "}
                <a href="mailto:support@academy-nest.com" className="text-blue-500 hover:underline">
                    support@academy-nest.com
                </a>.
            </p>
        </div>
    );
};

export default TermsAndPolicy;
